import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _14mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"14mp"}/>
}
